import { RECENT_SEARCHES_LIMIT } from 'constants/search'
import { take, uniqueBy } from 'lib/array/arrayUtils'
import * as isomorphicLocalStorage from 'lib/storage/isomorphicLocalStorage'

const EXPERIENCES_RECENT_SEARCHES_KEY = 'experiences-recent-searches'

function getExperienceRecentSearchKey(search: App.FullRecentSearch): string {
  return search.searchItem.value
}

function getExperienceRecentSearchId(searchItem: App.SearchItem, dates: App.SearchDates): string {
  return [
    dates.checkIn,
    dates.checkOut,
    dates.flexibleDuration,
    dates.flexibleMonths,
    searchItem.searchType,
    searchItem.value,
  ].join('-')
}

export function getLocalExperienceRecentSearches(): Array<App.FullRecentSearch> {
  const recentSearches = isomorphicLocalStorage.get(EXPERIENCES_RECENT_SEARCHES_KEY)
  return Array.isArray(recentSearches) ? recentSearches : []
}

function setLocalExperienceRecentSearches(recentSearches: Array<App.FullRecentSearch>) {
  isomorphicLocalStorage.set(EXPERIENCES_RECENT_SEARCHES_KEY, recentSearches)
}

export function saveExperienceRecentSearch(
  searchItem: App.SearchItem,
  dates: App.SearchDates,
  rooms: Array<App.Occupants>,
) {
  const recentSearch: App.FullRecentSearch = {
    searchItem,
    dates,
    rooms,
    recentSearchId: getExperienceRecentSearchId(searchItem, dates),
    dateAdded: new Date().toISOString(),
  }

  const nextSearches = take(
    uniqueBy(
      [recentSearch, ...getLocalExperienceRecentSearches()],
      getExperienceRecentSearchKey,
    ),
    RECENT_SEARCHES_LIMIT,
  )

  setLocalExperienceRecentSearches(nextSearches)
}

export function deleteExperienceRecentSearch(recentSearch: App.FullRecentSearch) {
  const key = getExperienceRecentSearchKey(recentSearch)
  setLocalExperienceRecentSearches(
    getLocalExperienceRecentSearches().filter(search => getExperienceRecentSearchKey(search) !== key),
  )
}

export function bumpExperienceRecentSearch(recentSearch: App.FullRecentSearch) {
  const key = getExperienceRecentSearchKey(recentSearch)
  const nextSearches = [
    recentSearch,
    ...getLocalExperienceRecentSearches().filter(search => getExperienceRecentSearchKey(search) !== key),
  ]

  setLocalExperienceRecentSearches(take(nextSearches, RECENT_SEARCHES_LIMIT))
}

function useExperienceRecentSearches(): Array<App.FullRecentSearch> {
  return getLocalExperienceRecentSearches()
}

export default useExperienceRecentSearches
